import { useEffect, useState } from "react";
import { Scale } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, formatError } from "@/lib/api";

export const WeightCard = ({ date, kg, week, onChanged }) => {
  const [v, setV] = useState("");

  useEffect(() => {
    setV(kg ?? "");
  }, [kg, date]);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/nutri/weight/${date}`, { kg: v === "" ? null : Number(v) });
      toast.success("Peso salvato");
      onChanged();
    } catch (err) {
      toast.error(formatError(err));
    }
  };

  const weights = (week?.days || []).filter((d) => d.weight_kg != null);
  const delta = weights.length > 1 ? Math.round((weights[weights.length - 1].weight_kg - weights[0].weight_kg) * 10) / 10 : null;

  return (
    <section data-testid="weight-card" className="border border-[rgba(152,191,162,0.15)] bg-[#0b120e] p-6">
      <div className="flex items-center justify-between">
        <p className="eyebrow">Peso corporeo</p>
        <Scale size={16} className="text-[#98bfa2]" />
      </div>
      <p className="mt-3 font-display text-5xl font-900"><span data-testid="weight-value">{kg ?? "—"}</span><span className="text-xl text-[#a3b1aa]"> kg</span></p>
      {delta !== null && (
        <p data-testid="weight-delta" className="mt-1 font-mono text-xs text-[#a3b1aa]">
          Ultimi 7 giorni: <span className="text-[#c4dcca]">{delta > 0 ? `+${delta}` : delta} kg</span>
        </p>
      )}
      <form onSubmit={save} className="mt-5 flex gap-2">
        <Input data-testid="weight-input" type="number" step="0.1" min="20" max="400" placeholder="es. 72.4" value={v} onChange={(e) => setV(e.target.value)} className="h-11 bg-[#050807]" />
        <button data-testid="weight-save-btn" className="bg-[#98bfa2] px-5 font-display text-lg font-800 uppercase text-[#050807] hover:bg-[#c4dcca]">Salva</button>
      </form>
    </section>
  );
};
